export default __webpack_public_path__ + "static/Plots0040-6115e0516ed2595019a48180793e8407.jpg";